<template>
    <div class="user-center">
        <div class="menus">
            <div class="menus-wrapper">
                <router-link to="/user" :class="{'menu': true, 'current': menuIndex==1}">個人信息</router-link>
                <router-link to="/user/pwd" :class="{'menu': true, 'current': menuIndex==2}">修改密碼</router-link>
                <router-link to="/user/myActivity" :class="{'menu': true, 'current': menuIndex==3}">我的活動/課程</router-link>
                <router-link to="/user/myQuestionCard" :class="{'menu': true, 'current': menuIndex==4}">我的問題卡</router-link>
                <a :href="webSite" class="menu bottom" target="_blank" title="香港中醫在綫"><img src="../../assets/imgs/img_logo@2x.png" alt="香港中醫在綫"></a>
            </div>
        </div>
        <router-view class="router-view"></router-view>
    </div>
</template>

<script>
    import Loading from '../Loading.vue'
    export default {
        components: { Loading },
        props: {
            callback: Function,
        },
        data(){
            return {
                userInfo: this.$store.getters.userInfo,
                association: this.$store.getters.association,
                menuIndex: 1,
                webSite: 'https://www.ectcm.com'
            }
        },
        mounted: function(){
            if(!this.$store.getters.userInfo) {
                this.$router.push('/')
                return
			}
            var path = this.$route.path
            if(path == '/user') {
                this.menuIndex = 1
            } else if(path == '/user/pwd') {
                this.menuIndex = 2
            } else if(path == '/user/myActivity') {
                this.menuIndex = 3
            } else if(path == '/user/myQuestionCard') {
                this.menuIndex = 4
            }

            this.webSite = 'https://www.ectcm.com'
            if(this.association) {
                if(this.association.domain && this.association.domain.indexOf('preview') != -1) {
                    this.webSite = 'https://preview.ectcm.com'
                }
            }
        },
        methods: {
        },
        watch: {
            $route: function(to, from) {
                if(!this.$store.getters.userInfo) {
                    this.$router.push('/')
                    return
                }
                var path = to.path
                if(path == '/user') {
                    this.menuIndex = 1
                } else if(path == '/user/pwd') {
                    this.menuIndex = 2
                } else if(path == '/user/myActivity') {
                    this.menuIndex = 3
                } else if(path == '/user/myQuestionCard') {
                    this.menuIndex = 4
                }
            }
        }
    }
</script>

<style scoped>
    .user-center {
        display: flex;
        flex-direction: row;
        width: 1000px;
        margin: 0 auto;
        flex: 1;
    }

    .user-center > .menus {
        width: 200px;
        margin-right: 10px;
        box-shadow: 3.5px 0.5px 2px #9999994f;
        border-radius: 2px;
        position: relative;
        padding-bottom: 58px;
    }

    .user-center > .menus > .menus-wrapper {
        display: flex;
        flex-direction: column;
        background-color: #fff;
    }

    .user-center > .menus .menu {
        height: 38px;
        line-height: 38px;
        padding: 0 12px;
        font-size: 16px;
        font-weight: 400;
        color: #232323;
        border-bottom: 1px solid #e8e8e8;
    }

     .user-center > .menus .menu.bottom {
        position: absolute;
        left: 12px;
        bottom: 12px;
     }

    .user-center > .menus .menu.current {
        font-weight: bold;
        color: #f00;
    }

    .user-center > .menus .menu:last-child {
        border-bottom: 0;
    }

    .user-center > .router-view {
        min-height: 350px;
        flex: 1;
        background-color: #fff;
    }

    @media only screen and (max-width: 1050px) {
        .user-center {
            width: 100%;
            display: flex;
            flex-direction: column;
            position: relative;
            padding-top: 198px;
        }

        .user-center > .menus {
            width: unset;
            position: absolute;
            background-color: #fff;
            border: 1px solid #eee;
            left: 12px;
            top: 12px;
            box-shadow: 2px 2px 5px #e8e8e8, -2px -2px 5px #e8e8e8;
            right: 0px;
        }
    }
</style>
